var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container"},[_c('el-image',{staticClass:"image-verification-code",attrs:{"src":_vm.data_web_common_kaptcha.img,"fit":"fill"},on:{"click":_vm.__btn_image_click}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }